import styled from 'styled-components';

export const VideoWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  overflow: hidden;
  transform: none;

  iframe {
    pointer-events: none;
    bottom: 0;
    right: 0;
    border: none;
    outline: none;
    width: 100vw;
    height: 56.25vw;
    min-height: 100vh;
      min-width: 40vh;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    @media (min-width: 576px) {
    min-width: 177.77vh;
    }
  }
`;
